import React from 'react';
import PropTypes from 'prop-types';
import BusinessCard from './BusinessCard';
import './BusinessGrid.css';
import { getServiceBySlug } from '../../data/categoryConfig';
const BusinessGrid = ({ 
  businesses, 
  loading, 
  onContact, 
  onViewDetails,
  categorySlug
}) => {
  if (loading) {
    return (
      <div className="business-grid loading">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Finding businesses...</p>
        </div>
      </div>
    );
  }

  const hasBusinesses = Array.isArray(businesses) && businesses.length > 0;

  if (!hasBusinesses) {
    const service = getServiceBySlug(categorySlug);

    if (!service) {
      return (
        <div className="business-grid empty">
          <div className="empty-state">
            <div className="empty-icon">🔍</div>
            <h3 className="empty-title">Category Not Found</h3>
            <p className="empty-subtitle">
              The category you&apos;re looking for doesn&apos;t exist.
              <br />
              Try browsing our popular services instead.
            </p>
            <div className="empty-actions">
              <a href="/index" className="back-home-btn">
                Browse Categories
              </a>
            </div>
          </div>
        </div>
      );
    }

    if (service.status === 'coming_soon') {
      return (
        <div className="business-grid empty coming-soon">
          <div className="empty-state">
            <div className="coming-soon-icon">🚧</div>
            <h3 className="empty-title">Coming Soon</h3>
            <p className="empty-subtitle">
              We&apos;re working on bringing the best {service.name} businesses to you.
              <br />
              Check back soon or list your business to be the first!
            </p>
            <div className="coming-soon-actions">
              <a href="/business-listing" className="list-business-btn">
                List Your Business
              </a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="business-grid empty">
        <div className="empty-state">
          <div className="empty-icon">📭</div>
          <h3 className="empty-title">No Businesses Yet</h3>
          <p className="empty-subtitle">
            We don&apos;t have any {service.name} businesses listed here right now.
            <br />
            You can browse other services or list your business.
          </p>
          <div className="empty-actions">
            <a href="/index" className="back-home-btn">
              Browse Categories
            </a>
            <a href="/business-listing" className="list-business-btn">
              List Your Business
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="business-grid">
      <div className="grid-container">
        {businesses.map((business) => (
          <BusinessCard
            key={business.id}
            business={business}
            onContact={onContact}
            onViewDetails={onViewDetails}
          />
        ))}
      </div>
      
      {/* Load More Button */}
      <div className="load-more-section">
        <button className="load-more-btn">
          Load More Businesses
        </button>
      </div>
    </div>
  );
};

BusinessGrid.propTypes = {
  businesses: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  onContact: PropTypes.func.isRequired,
  onViewDetails: PropTypes.func.isRequired,
  categorySlug: PropTypes.string.isRequired
};

export default BusinessGrid;
